<div class="card">
  <div class="surface-section grid">
    <div class="col-12 font-medium text-xl text-600 mb-3">
      Seleccionar Proveedor
    </div>
    <div class="col-12 col-md:col-6">
      <form [formGroup]="fg">
        <div class="mt-2 mb-2">
          <p-fieldset legend="Proveedor" [toggleable]="false">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <input
                  pInputText
                  formControlName="provider"
                  type="text"
                  readonly
                  placeholder="Pulse el botón para seleccionar proveedor"
                />
              </div>
              <div class="field col-12 md:col-1">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.provider.openDialog = true"
                  pTooltip="Seleccionar proveedor"
                  tooltipPosition="left"
                ></button>
              </div>

              <div class="field col-12 md:col-1">
                <button
                  pButton
                  pRipple
                  icon="pi pi-user-plus"
                  class="p-button-rounded p-button-warning"
                  (click)="openProviderCreate = true"
                  pTooltip="Crear proveedor"
                  tooltipPosition="left"
                ></button>
              </div>

            </div>
          </p-fieldset>
        </div>
      </form>

      <div class="justify-content-end p-fluid p-formgrid grid">
        <div class="field col-12 mt-4 md:col-4">
          <button
            pButton
            pRipple
            type="button"
            label="Siguiente"
            (click)="nextPage()"
            [disabled]="!providerSelected"
            icon="pi pi-angle-right"
            iconPos="right"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

<pg-provider-create
  *ngIf="openProviderCreate"
  (close)="openProviderCreate=false"
>
</pg-provider-create>

<pg-provider-select
  *ngIf="select.provider.openDialog"
  [typeSelect]="select.provider.typeSelect"
  (selectedRowsEvent)="onSelectedProvider($event)"
>
</pg-provider-select>
